<template>
  <svg
    class="group-213"
    width="37"
    height="6"
    viewBox="0 0 37 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.29485 3.33987C6.29485 4.09334 6.0638 4.6968 5.60862 5.14685C5.08528 5.68037 4.40367 5.94882 3.5684 5.94882C2.77011 5.94882 2.08849 5.67586 1.52934 5.13783C0.969027 4.5919 0.689453 3.92189 0.689453 3.11992C0.689453 2.31795 0.969027 1.64794 1.52934 1.10653C2.08849 0.563981 2.77011 0.291016 3.5684 0.291016C3.96582 0.291016 4.34474 0.3711 4.70635 0.51999C5.06679 0.670008 5.36023 0.873039 5.5728 1.12344L5.0899 1.59944C4.71906 1.17195 4.2142 0.96102 3.5684 0.96102C2.98614 0.96102 2.48129 1.15954 2.05268 1.55996C1.62869 1.96151 1.41612 2.4815 1.41612 3.11992C1.41612 3.75834 1.62869 4.28284 2.05268 4.68439C2.48129 5.0803 2.98614 5.28333 3.5684 5.28333C4.18648 5.28333 4.70635 5.0803 5.11647 4.67988C5.38681 4.41481 5.54046 4.04935 5.58089 3.58238H3.5684V2.93042H6.25326C6.28561 3.07142 6.29485 3.2079 6.29485 3.33987Z"
      fill="white"
      stroke="white"
      stroke-width="0.097883"
      stroke-miterlimit="10"
    />
    <path
      d="M10.5543 1.08038H8.03232V2.79487H10.3059V3.44682H8.03232V5.16131H10.5543V5.82568H7.31836V0.416016H10.5543V1.08038Z"
      fill="white"
      stroke="white"
      stroke-width="0.097883"
      stroke-miterlimit="10"
    />
    <path
      d="M13.5597 5.82568H12.8457V1.08038H11.2988V0.416016H15.1078V1.08038H13.5597V5.82568Z"
      fill="white"
      stroke="white"
      stroke-width="0.097883"
      stroke-miterlimit="10"
    />
    <path
      d="M17.8633 5.82568V0.416016H18.5761V5.82568H17.8633Z"
      fill="white"
      stroke="white"
      stroke-width="0.097883"
      stroke-miterlimit="10"
    />
    <path
      d="M21.7374 5.82568H21.0292V1.08038H19.4766V0.416016H23.2901V1.08038H21.7374V5.82568Z"
      fill="white"
      stroke="white"
      stroke-width="0.097883"
      stroke-miterlimit="10"
    />
    <path
      d="M30.5005 5.1288C29.9541 5.67586 29.2771 5.94882 28.4696 5.94882C27.6574 5.94882 26.9804 5.67586 26.434 5.1288C25.8887 4.58288 25.6172 3.91287 25.6172 3.11992C25.6172 2.32697 25.8887 1.65697 26.434 1.11104C26.9804 0.56398 27.6574 0.291016 28.4696 0.291016C29.2725 0.291016 29.9495 0.56398 30.4959 1.11555C31.0458 1.66599 31.3173 2.33148 31.3173 3.11992C31.3173 3.91287 31.0458 4.58288 30.5005 5.1288ZM26.9619 4.67537C27.3732 5.0803 27.8734 5.28333 28.4696 5.28333C29.0611 5.28333 29.5659 5.0803 29.9726 4.67537C30.3827 4.27043 30.5907 3.75045 30.5907 3.11992C30.5907 2.4894 30.3827 1.96941 29.9726 1.56447C29.5659 1.15954 29.0611 0.956508 28.4696 0.956508C27.8734 0.956508 27.3732 1.15954 26.9619 1.56447C26.5518 1.96941 26.3439 2.4894 26.3439 3.11992C26.3439 3.75045 26.5518 4.27043 26.9619 4.67537Z"
      fill="white"
      stroke="white"
      stroke-width="0.097883"
      stroke-miterlimit="10"
    />
    <path
      d="M32.3223 5.82568V0.416016H33.1887L35.8828 4.62328H35.914L35.8828 3.58331V0.416016H36.5956V5.82568H35.8516L33.0304 1.41087H32.9993L33.0304 2.45535V5.82568H32.3223Z"
      fill="white"
      stroke="white"
      stroke-width="0.097883"
      stroke-miterlimit="10"
    />
  </svg>
</template>
